import SectionDividerWithText from './SectionDividerWithText';

export default SectionDividerWithText;
